import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Layout from './components/Layout/Layout';
import SmoothScroll from './components/SmoothScroll';
import AnimatedRoutes from './components/Layout/AnimatedRoutes';
import { EnquiryProvider } from './context/EnquiryContext';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    // Refresh ScrollTrigger on window resize
    const handleResize = () => {
      ScrollTrigger.refresh();
    };

    window.addEventListener('resize', handleResize);

    // Initial refresh
    ScrollTrigger.refresh();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <EnquiryProvider>
        <SmoothScroll>
          <Layout>
            <AnimatedRoutes />
          </Layout>
        </SmoothScroll>
      </EnquiryProvider>
    </Router>
  );
}

export default App;
